import { gtag } from "../utility-functions/utility-functions";

/* global var paypal */
declare var paypal: any;

export default function () {
    let buttonContainer;
    const customerGUID = window.paypalCustomerGuid;
    buttonContainer = document.querySelector('.js-paypal-button-container');
    if (typeof paypal === 'undefined') return;
    paypal
        .Buttons({
            style: {
                color: 'gold',
                shape: 'rect',
                label: 'checkout',
                height: 50,
                size: 'responsive'
            },
            createOrder: function (e) {
                try {
                    var formData = new FormData();
                    formData.append('userGuid', customerGUID);
                    formData.append('area', 'basket');
                    return fetch('/checkout/payment/CreatePayPalBasket', {
                        method: 'post',
                        body: formData
                    })
                        .then(function (res) {
                            return res.json();
                        })
                        .then(function (data) {
                            (document.getElementById('payPalOrderid') as HTMLInputElement).value = data.reference;
                            return data.orderID;
                        });
                } catch (error) {
                    alert(error);
                    console.log(error);
                }
            },
            onShippingChange: function (data, actions) {
                var formData = new FormData();
                formData.append('Id', data.orderID);
                formData.append('OrderReference', (document.getElementById('payPalOrderid') as HTMLInputElement).value);
                formData.append('userGuid', customerGUID);
                formData.append('area', 'basket');
                formData.append('countryCode', data.shipping_address.country_code);
                formData.append('postcode', data.shipping_address.postal_code);
                formData.append('CurrencyCode', data.amount.currency_code);
                formData.append('Value', data.amount.value);

                try {
                    return fetch('/checkout/payment/AmendPaypal', {
                        method: 'post',
                        body: formData
                    })
                        .then(function (res) {
                            return res.json();
                        })
                        .then(function (data) {
                            if (data.isSuccess === true) {
                                return actions.resolve();
                            } else {
                                return actions.reject();
                            }
                        });
                } catch (error) {
                    alert(error);
                }
            },
            onError: function (err) {
                try {
                    window.location.href = '/basket?error=paypal';
                } catch (error) {
                    alert(error);
                }
            },
            onClick: function () {
                const selectedDelivery = document.querySelector<HTMLElement>('.js-accordion-option.delivery-option.is-selected')?.dataset.title;
                if (selectedDelivery) gtag('event', 'payment_option_clicked', { selected_delivery_option: selectedDelivery });
            },
            onApprove: function (data, actions) {
                try {
                    var formData = new FormData();
                    formData.append('userGuid', customerGUID);
                    formData.append('area', 'basket');
                    formData.append('Id', data.orderID);
                    formData.append('paymentId', data.paymentID);
                    formData.append('OrderReference', (document.getElementById('payPalOrderid') as HTMLInputElement).value);

                    return fetch('/checkout/payment/CapturePaypal', {
                        method: 'post',
                        body: formData
                    })
                        .then(function (res) {
                            return res.json();
                        })
                        .then(function (responseData) {
                            if (responseData.PaypalResponse === 'INSTRUMENT_DECLINED') {
                                return actions.restart();
                            }
                            window.location.href = '/checkout/thankyou';
                        });
                } catch (error) {
                    console.log(error);
                }
            }
        })
        .render(buttonContainer);
}
